import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getProject } from "api/project.api";
import { ProjectDetails } from "interfaces/IProject";

interface ProjectState {
  projects_data: ProjectDetails[];
  selected_project: any;
  loading: boolean;
  error: string | null;
  refresher: number | null;
  update_project: boolean;
  importedCandidates: number;
  shortlistedCandidates: number;
  rejectedCandidates: number;
}

const initialState: ProjectState = {
  projects_data: [],
  selected_project: {},
  update_project: false,
  loading: false,
  error: null,
  refresher: null,
  importedCandidates: 0,
  shortlistedCandidates: 0,
  rejectedCandidates: 0,
};

export const doGetProjectsList = createAsyncThunk("projects/doGetProjectsList", async () => {
  const response = await getProject();
  return response.results;
});

const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setRefresher: (state) => {
      state.refresher = Math.random();
    },
    setProjectsData: (state, action: PayloadAction<any[]>) => {
      // Updated to accept an array of selected candidates
      state.projects_data = action.payload;
    },
    setSelectedProjectData: (state, action: PayloadAction<any>) => {
      state.selected_project = action.payload;
    },
    setSelectedProjectUpdateData: (state, action: PayloadAction<any>) => {
      state.update_project = action.payload;
    },
    setImportedCandidates: (state, action: PayloadAction<number>) => {
      state.importedCandidates = action.payload;
    },
    setShortlistedCandidates: (state, action: PayloadAction<number>) => {
      state.shortlistedCandidates = action.payload;
    },
    setRejectedCandidates: (state, action: PayloadAction<number>) => {
      state.rejectedCandidates = action.payload;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(doGetProjectsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(doGetProjectsList.fulfilled, (state, action) => {
        state.loading = false;
        state.projects_data = action.payload;
      })
      .addCase(doGetProjectsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch projects";
      });
  },
});
export const {
  setRefresher,
  setProjectsData,
  setSelectedProjectData,
  setSelectedProjectUpdateData,
  setImportedCandidates,
  setShortlistedCandidates,
  setRejectedCandidates,
} = projectSlice.actions;
export default projectSlice.reducer;

// // Redux Toolkit slice
// const projectSlice = createSlice({
//   name: "projects",
//   initialState,
//   reducers: {
//     setProjectsData: (state, action: PayloadAction<any[]>) => {  // Updated to accept an array of selected candidates
//       state.projects_data = action.payload;
//     },
//   },
// });

// // Export the actions
// export const { setProjectsData } = projectSlice.actions;

// // Export the reducer
// export default projectSlice.reducer;
